"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAuthEndpoints = createAuthEndpoints;
/**
 * Kimlik: OTP, OAuth, jeton yenileme ve oturum yönetimi.
 *
 * BU DOSYA YALNIZ ÜRÜN KİMLİĞİDİR. Personel kimliği `endpoints/staff.ts`
 * içindedir ve `/panel/auth/*` altında yaşar (panel kimliği ayrımı · Karar 3b);
 * iki yüzey ayrı imza anahtarı ve ayrı audience taşır, jetonları birbirinin
 * yerine geçemez.
 *
 * ÜRÜN ŞİFRESİ (kullanıcı kararı 05.09.2026): `register` · `confirmRegistration`
 * · `login` · `forgotPassword` · `resetPassword`. `requestOtp`/`verifyOtp`
 * YERİNDE KALIR ama ŞİFRESİZ hesaplara daralır (K5) — şifreli bir hesap için
 * kod istendiğinde yanıt aynıdır, kod GİTMEZ.
 */
function createAuthEndpoints(client) {
    return {
        auth: {
            requestOtp: (input) => client.call('/auth/otp/request', 'post', { body: input }),
            verifyOtp: (input) => client.call('/auth/otp/verify', 'post', { body: input }),
            /**
             * Kayıt 1. adım: e-posta + rıza. ŞİFRE ALMAZ (06.09.2026) — hesap
             * ONAYLANMAMIŞ ve ŞİFRESİZ açılır, 6 haneli kod gider (K2). Şifre
             * `confirmRegistration` isteğinde gönderilir.
             */
            register: (input) => client.call('/auth/register', 'post', { body: input }),
            /**
             * K4 · genel kayıtta bekleyen kurum daveti: kayıt koduyla sorulur, kod
             * TÜKETİLMEZ. Doluysa ekran "kurum hesabı olarak devam et" satırını çizer.
             */
            registrationInvitation: (input) => client.call('/auth/register/pending-invitation', 'post', { body: input }),
            /** Kayıt 2. adım: kod + ŞİFRE → hesap aktif, özet yazılır, OTURUM AÇILIR. */
            confirmRegistration: (input) => client.call('/auth/register/confirm', 'post', { body: input }),
            /** Şifreli giriş (K3). Tek genel hata: `CREDENTIALS_INVALID`. */
            login: (input) => client.call('/auth/login', 'post', { body: input }),
            /** Şifremi unuttum 1. adım — adres yoksa da AYNI yanıt (K10). */
            forgotPassword: (input) => client.call('/auth/password/forgot', 'post', { body: input }),
            /** Şifremi unuttum 2. adım — kodu tüketir, OTURUM AÇMAZ. */
            resetPassword: (input) => client.call('/auth/password/reset', 'post', { body: input }),
            /**
             * HASSAS İŞLEM KODU (dışa aktarma · hesap silme). OTURUM İSTER ve gövde
             * ALMAZ: kod çağıranın KENDİ adresine gider. Şifreli hesaplar için
             * `requestOtp` bu amaçla ARTIK KULLANILAMAZ (K5).
             */
            requestStepUpOtp: () => client.call('/auth/step-up/request', 'post', {}),
            oauth: (input) => client.call('/auth/oauth', 'post', { body: input }),
            /** K4 · Google/Apple ile bekleyen kurum daveti sorusu; hesap AÇMAZ. */
            oauthInvitation: (input) => client.call('/auth/oauth/pending-invitation', 'post', { body: input }),
            refresh: (input) => client.call('/auth/refresh', 'post', { body: input }),
            logout: (options) => client.call('/auth/logout', 'post', { keepalive: options?.keepalive }),
            sessions: () => client.call('/auth/sessions', 'get', {}),
            revokeSession: (sessionId) => client.call('/auth/sessions/{id}', 'delete', { path: { id: sessionId } }),
            revokeAllSessions: () => client.call('/auth/sessions', 'delete', {}),
        },
    };
}
//# sourceMappingURL=auth.js.map